export const GetIsFreeViewService = Symbol('GetIsFreeViewService');

export interface GetIsFreeViewService {
    getIsFreeView: () => boolean;
}
